import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import { profileRoute } from '.'

const TransactionHistory = lazyRouteComponent(
  () => import('../../pages/profile/transaction-history'),
)

export const transactionHistoryRoute = createRoute({
  getParentRoute: () => profileRoute,
  path: 'transaction-history',
  component: TransactionHistory,
})
